module.exports = __webpack_public_path__ + "media/images/application/icons/icon-check-thick-6233be9592d61b58d1aa971ff1d6f680.svg";